import { DiModuleBuilder } from "@iot-platform/core";
import { ReportDatasource } from "@report/data/datasources/report.datasource";
import { ReportDailyActivityMapper } from "@report/data/mappers/report-daily-activity.mapper.ts";
import { ReportDetailedStateMapper } from "@report/data/mappers/report-detailed-state.mapper.ts";
import { ReportPoisRoutesMapper } from "@report/data/mappers/report-pois-routes.mapper.ts";
import { ReportPoisVisitedMapper } from "@report/data/mappers/report-pois-visited.mapper.ts";
import { ReportRouteGpsMapper } from "@report/data/mappers/report-route-gps.mapper.ts";
import { ReportStateGpsMapper } from "@report/data/mappers/report-state-gps.mapper.ts";
import { ReportTraveledKilometersMapper } from "@report/data/mappers/report-traveled-kilometers.mapper.ts";
import { ReportMapper } from "@report/data/mappers/report.mapper";
import { ReportImplRepository } from "@report/data/repositories/report.impl-repository";
import type { ReportRepository } from "@report/domain/repositories/report.repository";
import { ReportGetHistoricalCustomUseCase } from "@report/domain/usecases/report-get-historical-custom.usecase";
import { ReportGetDailyActivityGpsUsecase } from "@report/domain/usecases/report-get-historical-daily-activity-gps.usecase.ts";
import { ReportGetHistoricalDetailStateGpsUsecase } from "@report/domain/usecases/report-get-historical-detailed-state-gps.usecase.ts";
import { ReportGetHistoricalPoisRoutesUsecase } from "@report/domain/usecases/report-get-historical-pois-routes.usecase.ts";
import { ReportGetHistoricalPoisVisitedUsecase } from "@report/domain/usecases/report-get-historical-pois-visited.usecase.ts";
import { ReportGetHistoricalStateGpsUsecase } from "@report/domain/usecases/report-get-historical-state-gps.usecase.ts";
import { ReportGetTraveledKilometersUsecase } from "@report/domain/usecases/report-get-historical-traveled-kilometers.usecase.ts";
import { ReportGetHistoricalUseCase } from "@report/domain/usecases/report-get-historical.usecase";
import { ReportGetRouteGpsUseCase } from "@report/domain/usecases/report-get-route-gps.usecase.ts";
import { ReportHistoricalRequestMailUseCase } from "@report/domain/usecases/report-historical-request-mail.usecase.ts";
import { DatesFilterViewmodel } from "@report/presentation/components/dates-filter/dates-filter.viewmodel";
import { HistoricalCustomFilterViewmodel } from "@report/presentation/components/historical-custom-filter/historical-custom-filter.viewmodel";
import { HistoricalFilterViewmodel } from "@report/presentation/components/historical-filter/historical-filter.viewmodel";
import { HistoricalRouteGpsFilterViewmodel } from "@report/presentation/components/historical-route-gps-filter/historical-route-gps-filter.viewmodel.ts";
import { HistoricalViewmodel } from "@report/presentation/pages/historical/historical.viewmodel.ts";
import { ReportPageViewmodel } from "@report/presentation/pages/report/report.viewmodel";
import { reportTypes } from "@report/report-types.di";
import { ContainerModule } from "inversify";

const webReportModule = new DiModuleBuilder();

webReportModule.registerSubModules(() => ({
    datasources: new ContainerModule(({ bind }) => {
        bind(ReportDatasource).toSelf();
    }),
    mappers: new ContainerModule(({ bind }) => {
        bind(ReportMapper).toSelf();
        bind(ReportRouteGpsMapper).toSelf();
        bind(ReportDailyActivityMapper).toSelf();
        bind(ReportDetailedStateMapper).toSelf();
        bind(ReportPoisRoutesMapper).toSelf();
        bind(ReportPoisVisitedMapper).toSelf();
        bind(ReportStateGpsMapper).toSelf();
        bind(ReportTraveledKilometersMapper).toSelf();
    }),
    repositories: new ContainerModule(({ bind }) => {
        bind<ReportRepository>(reportTypes.repositories.ReportRepository).to(
            ReportImplRepository,
        );
    }),
    useCases: new ContainerModule(({ bind }) => {
        bind(ReportGetHistoricalCustomUseCase).toSelf();
        bind(ReportGetDailyActivityGpsUsecase).toSelf();
        bind(ReportGetHistoricalDetailStateGpsUsecase).toSelf();
        bind(ReportGetHistoricalPoisRoutesUsecase).toSelf();
        bind(ReportGetHistoricalPoisVisitedUsecase).toSelf();
        bind(ReportGetHistoricalStateGpsUsecase).toSelf();
        bind(ReportGetTraveledKilometersUsecase).toSelf();
        bind(ReportGetHistoricalUseCase).toSelf();
        bind(ReportGetRouteGpsUseCase).toSelf();
        bind(ReportHistoricalRequestMailUseCase).toSelf();
    }),
    viewModels: new ContainerModule(({ bind }) => {
        bind(DatesFilterViewmodel).toSelf();
        bind(HistoricalCustomFilterViewmodel).toSelf();
        bind(HistoricalFilterViewmodel).toSelf();
        bind(HistoricalRouteGpsFilterViewmodel).toSelf();
        bind(HistoricalViewmodel).toSelf();
        bind(ReportPageViewmodel).toSelf();
    }),
}));

webReportModule.registerModule();

export { webReportModule };
